<template lang="pug">
  v-text-field( 
    :value="value"
    :label="label" 
    :type="type" 
    :rules="rules"
    :readonly="readonly"
    :counter="counter"
    outlined 
    :hide-details="hideDetails"
    :dense="dense"
    light
    color="blue"
    :autofocus="focus"
    :disabled="disabled"
    :error-messages="errorText" 
    :prepend-inner-icon="prependIcon"
    :prepend-icon="prependOuterIcon"
    :append-icon="appendIcon"
    :append-outer-icon="appendOuterIcon"
    :clearable="clearable"
    @change="handleChange" 
    @keyup.enter="handleKeyUp"
    @input="handleInput"
    @click:prepend="$emit('click:prepend-outer')" 
    @click:append-outer="$emit('click:append-outer')"
    @click:append="$emit('click:append')"
  )
</template>

<script>
export default {
  inheritAttrs: true,
  name: 'app-text-field',
  props: {
    value: [String, Number],
    label:  String,
    type: {
      type: String,
      default: 'text'
    },
    focus: {
      type: Boolean,
      default: false
    },
    errorText: String,
    prependIcon:  String,
    prependOuterIcon:  String,
    appendIcon: String,
    appendOuterIcon: String,
    readonly: Boolean,
    disabled: Boolean,
    rules: [Object, Array],
    counter: [Boolean, Number, String],
    clearable: Boolean, 
    hideDetails: {
      type: Boolean, 
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      timeout: null
    }
  },

  methods: {
    handleChange (event) {
      this.$emit('change', event)
    },

    handleKeyUp (event) {
      this.$emit('keyup', event)
    },

    handleInput (event) {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(() => {
        this.$emit('input', event)
      }, 100)
    }
  }
}
</script>

<style scoped>

</style>

